<template>
  <div>
    <div v-for="(item, index) in items" :key="index">
      <slot v-if="rendered || index < renderedItemsCount" :item="item" :index="index"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'partial-renderer',

    props: {
      items: {
        type: Array
      },
      delay: {
        type: [Number, String],
        default: 0.1
      },
      forceRenderItems: {
        type: [Number, String],
        default: 1
      },
      step: {
        type: [Number, String],
        default: 1
      }
    },
    data() {
      return {
        renderedItemsCount: 0,
        rendered: false,
        showUpload: false,
        projectIdUpload: null,
      }
    },
    created() {
      this.renderedItemsCount = parseInt(this.forceRenderItems);
    },
    mounted() {
      this.renderNext();
    },
    computed: {
      delayMilliseconds() {
        return this.delay * 1000;
      },

      count() {
        return this.items.length;
      }
    },
    methods: {
      onDrop() {

      },
      onDropStop(ev){
        console.log(this)
        this.$refs.uploadFiles.addFiles(ev.dataTransfer.files,'1');
        //this.projectIdUpload = id;
        //this.setFiles = ev.dataTransfer.files; @dragover.stop.prevent="onDrop"  @drop.prevent="onDropStop"
        this.showUpload = false;
      },
      renderNext() {
        setTimeout(() => {
          this.$nextTick(() => {
            this.renderedItemsCount += parseInt(this.step);
            if (this.count > this.renderedItemsCount) {
              this.renderNext();
            } else {
              this.rendered = true;
            }
          })
        }, this.delayMilliseconds);
      }
    }
  }
</script>
